import React, { FunctionComponent } from "react";
import { NTBCNavigation } from "../../sections/hero";
import gears2 from "../../assets/lottie/19748-gear-animation.json";
import Lottie from "lottie-react";

const BASE_URL = "https://cdn.chuuma.io/ntbc/";

const reports = [
  {
    title: "2019 Annual Report",
    filename:
      "National Technology Business Centre (NTBC) 2019 ANNUAL REPORT- final 12.06.24 (3).pdf",
  },
  {
    title: "2020 Annual Report",
    filename:
      "National Technology Business Centre (NTBC) 2020 ANNUAL REPORT- final 12.06.24 (4).pdf",
  },
  {
    title: "2021 Annual Report",
    filename:
      "National Technology Business Centre (NTBC) FINAL DRAFT 2021 ANNUAL REPORT _ 01.10.2024 (4).pdf",
  },
  {
    title: "2022 Annual Report",
    filename:
      "National Technology Business Centre (NTBC) 2022 ANNUAL REPORT _ 01.10.2024 (4).pdf",
  },
  {
    title: "2023 Annual Report",
    filename: "NTBC 2023 ANNUAL REPORT - DRAFT 3 (1).pdf",
  },
  {
    title: "2024 Annual Report",
    filename: "NTBC 2024 ANNUAL REPORT - DRAFT 5 (1).pdf",
  },
];

export const NTBCPublications: FunctionComponent = () => {
  return (
    <div>
      <div className="relative bg-green-50 overflow-hidden">
        <div className="relative pt-6 px-4 sm:px-6 lg:px-8 z-10">
          <NTBCNavigation />
        </div>
        <main className="text-center mt-8 mx-auto max-w-screen-xl px-4 sm:mt-12 sm:px-6 md:mt-8 lg:mt-8 lg:px-8 xl:mt-10">
          <div className="sm:text-center lg:text-left">
            <p className="pb-6 text-gray-500">
              National Technology and Business Centre
            </p>
            <h2 className="text-4xl tracking-tight leading-10 font-extrabold text-gray-900 sm:text-5xl sm:leading-none md:text-6xl">
              Annual&nbsp;
              <span className="text-green-600">Reports</span>
            </h2>
            <p className="mt-3 text-gray-800 sm:mt-5 sm:max-w-xl sm:mx-auto md:mt-5 lg:mx-0 mb-4">
              Download or view NTBC annual reports.
            </p>
          </div>
        </main>
        <div className="absolute top-0 inset-x-0 sm:left-8 sm:w-1/2 opacity-25">
          <Lottie animationData={gears2} />
        </div>
      </div>
      <section className="bg-white px-8 py-16">
        <div className="container mx-auto max-w-screen-md">
          <div className="divide-y divide-gray-200">
            {reports.map((report) => {
              const url = BASE_URL + encodeURIComponent(report.filename);
              return (
                <div
                  key={report.filename}
                  className="flex items-center justify-between py-4"
                >
                  <span className="text-gray-800 font-medium">
                    {report.title}
                  </span>
                  <div className="flex gap-3">
                    <a
                      href={url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-green-600 border border-green-600 py-1 px-4 rounded hover:bg-green-50 transition duration-150 ease-in-out text-sm"
                    >
                      View
                    </a>
                    <a
                      href={url}
                      download={report.title + ".pdf"}
                      className="text-white bg-green-600 py-1 px-4 rounded hover:bg-green-800 transition duration-150 ease-in-out text-sm"
                    >
                      Download
                    </a>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>
    </div>
  );
};
